let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lx17z")).then(() => parcelRequire('dMM4v'));